"use strict";

// Управление куками.

function CookieManager() {
    this.storage = null;
}

CookieManager.prototype.has = function (name) {
    this.parseAll();
    return this.storage.hasOwnProperty(name);
};

CookieManager.prototype.get = function (name) {
    this.parseAll();
    return this.storage[name] || null;
};

CookieManager.prototype.set = function (name, value, days) {
    // var cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
    var cookie = name + "=" + value;
    if (days) {
        var expireDate = new Date();
        expireDate.setTime(expireDate.getTime() + days * 24 * 60 * 60 * 1000);
        cookie += ";expires=" + expireDate.toUTCString();
    }
    cookie += ";path=/";
    document.cookie = cookie;
    this.parseAll();
    this.storage[name] = value;
};

CookieManager.prototype.parseAll = function () {
    var self = this;
    function parseCookie(cookie) {
        var parts = cookie.split("=");
        var name = parts[0].trim();
        var value = parts[1].trim();
        self.storage[name] = value;
    }
    if (self.storage) {
        return;
    }
    self.storage = {};
    if (!document.cookie) {
        return;
    }
    var cookies = document.cookie.split(";");
    cookies.forEach(parseCookie);
};

var manager = new CookieManager();

export default {
    has: manager.has.bind(manager),
    get: manager.get.bind(manager),
    set: manager.set.bind(manager),
};
